import {Collection} from 'vue-mc'
import {ClientDashboardModel} from '@/models/clientDashboardModel'

export default class clientDashboardCollection extends Collection {

	// Default attributes that define the "empty" state.
	defaults() {
		return {

		}
	}

	model() {
		return ClientDashboardModel;
	}

	// Route configuration
	routes() {
		return {
			fetch: "clients/custom/dashboard",
			pages: "clients/custom/dashboard/pages"
		}
	}
}



// WEBPACK FOOTER //
// ./src/collections/clientDashboardCollection.js